import Loader from 'components/Loader';
import Paginate from 'components/Paginate';
import TableError from 'components/TableError';
import useRequest from 'hooks/useRequest';
import { isEmpty, map } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Badge, Button, DropdownItem, DropdownMenu, DropdownToggle, Table, UncontrolledDropdown } from 'reactstrap';
import { SORT_VALUES_CREATED_DATE } from 'utils/constants';
import UpdateSchoolDocuments from './UpdateSchoolDocuments';
import { Divider } from '@material-ui/core';
import { titleCaseIfExists } from 'utils/helper';
import { toast } from 'react-toastify';

const SchoolDocuments = ({ schoolId }) => {
  const [isOpen, setIsOpen] = useState(false);

  const [selectedDocument, setSelectedDocument] = useState(null);
  const [documentsList, setDocumentsList] = useState([]);
  const [documentsPagination, setDocumentsPagination] = useState({});

  const toggle = () => {
    setIsOpen(!isOpen);
    setSelectedDocument(null);
  };

  const [getSchoolDocumentsRequest, { loading: getSchoolDocumentsRequestLoading }] = useRequest({
    url: '/school/admin/marketing-document/search',
    method: 'POST',
    onSuccess: (data) => {
      setDocumentsList(data?.results);
      setDocumentsPagination(data?.pagination);
    },
  });

  const [updateDocumentRequest, { loading: updateDocumentRequestLoading }] = useRequest({
    method: 'PUT',
    onSuccess: () => {
      handleChangePage(1);
      toast.success('School Document has been updated');
    },
  });

  const handleChangePage = (page) => {
    getSchoolDocumentsRequest({
      body: {
        page: page ? page : 1,
        size: 20,
        schoolId,
        ...SORT_VALUES_CREATED_DATE,
      },
    });
  };

  const handleActive = (elem) => {
    updateDocumentRequest({
      url: `/school/admin/marketing-document/${elem?.id}`,
      body: {
        ...elem,
        active: !elem.active,
        deleted: false,
      },
    });
  };

  const handleDelete = (elem) => {
    updateDocumentRequest({
      url: `/school/admin/marketing-document/${elem?.id}`,
      body: {
        ...elem,
        deleted: !elem.deleted,
        active: false,
      },
    });
  };

  useEffect(() => {
    getSchoolDocumentsRequest({
      body: {
        page: 1,
        size: 20,
        schoolId,
        ...SORT_VALUES_CREATED_DATE,
      },
    });
  }, []);

  return (
    <div>
      <Loader isActive={getSchoolDocumentsRequestLoading || updateDocumentRequestLoading} />
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h4>School Documents</h4>

        <Button color="success" onClick={toggle}>
          <i className="bx bx-plus me-2" />
          Add document
        </Button>
      </div>

      <div>
        <div className="table-responsive" style={{ minHeight: 300 }}>
          <Table className="project-list-table table-nowrap table-centered table-borderless">
            <thead>
              <tr className="table-warning">
                <th scope="col">#Id</th>
                <th scope="col">Title</th>
                <th scope="col">Type</th>
                <th scope="col">Academic Year</th>
                <th scope="col">URL</th>
                <th scope="col">Active</th>
                <th scope="col">Deleted</th>
                <th scope="col" />
              </tr>
            </thead>
            <tbody>
              {!isEmpty(documentsList) ? (
                map(documentsList, (document, index) => {
                  const documentURL = !isEmpty(document?.url)
                    ? document?.url
                    : !isEmpty(document?.document?.original)
                    ? process.env.REACT_APP_SCHOOLMYKIDS_AWS_S3_CLOUDFRONT_URL + '/' + document?.document?.original
                    : '';
                  return (
                    <tr key={index} className={document?.deleted || !document?.active ? 'bg-danger' : ''}>
                      <td>{document?.id} </td>
                      <td>{document?.title}</td>
                      <td>{titleCaseIfExists(document?.type)} </td>
                      <td>{document?.academicYear} </td>
                      <td>
                        {!isEmpty(documentURL) && (
                          <a
                            href={documentURL}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              wordBreak: 'break-all',
                              whiteSpace: 'normal',
                              overflowWrap: 'break-word',
                              display: 'block',
                            }}>
                            {documentURL}
                          </a>
                        )}
                      </td>

                      <td>
                        <Badge className={document?.active ? 'bg-success' : 'bg-danger'}>
                          {document?.active ? 'Yes' : 'No'}
                        </Badge>
                      </td>
                      <td>
                        <Badge className={document?.deleted ? 'bg-success' : 'bg-danger'}>
                          {document?.deleted ? 'Yes' : 'No'}
                        </Badge>
                      </td>
                      <td>
                        <UncontrolledDropdown>
                          <DropdownToggle href="#" className="card-drop " tag="i">
                            <i role="button" className="mdi mdi-dots-vertical font-size-18 " />
                          </DropdownToggle>
                          <DropdownMenu className="dropdown-menu-end">
                            <DropdownItem onClick={() => handleActive(document)}>
                              <i
                                className={`fas  ${
                                  document?.active ? 'fa-ban text-danger' : 'fa-power-off text-success'
                                }   m-1 pe-3`}
                              />
                              {document?.active ? 'Disable' : 'Enable'}
                            </DropdownItem>

                            <DropdownItem onClick={() => handleDelete(document)}>
                              <i className={'fas fa-trash-alt text-danger m-1 pe-3'} />
                              {document?.deleted ? 'Undelete' : 'Delete'}
                            </DropdownItem>

                            <DropdownItem
                              onClick={() => {
                                toggle();
                                setSelectedDocument(document);
                              }}>
                              <i className="fas fa-pencil-alt text-success m-1 pe-3 " />
                              Edit
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <TableError />
              )}
            </tbody>
          </Table>
        </div>

        {!isEmpty(documentsList) && <Paginate pageInfo={documentsPagination} onChangePage={handleChangePage} />}
      </div>

      <UpdateSchoolDocuments
        schoolId={schoolId}
        isOpen={isOpen}
        toggle={toggle}
        selectedDocument={selectedDocument}
        handleChangePage={handleChangePage}
      />
    </div>
  );
};

export default SchoolDocuments;
